import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "item", "count", "bar", "acceptIds", "rejectIds"]

  toggle() {
    this.updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.itemTargets.forEach(cb => cb.checked = checked)
    this.updateState()
  }

  updateState() {
    const checked = this.itemTargets.filter(cb => cb.checked)
    const count = checked.length
    const ids = checked.map(cb => cb.value)

    // Update select-all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = count > 0 && count === this.itemTargets.length
      this.selectAllTarget.indeterminate = count > 0 && count < this.itemTargets.length
    }

    // Show/hide bulk bar
    this.barTarget.classList.toggle("hidden", count === 0)

    // Update count text
    this.countTarget.textContent = `${count} selected`

    // Sync hidden inputs
    this.syncHiddenInputs(this.acceptIdsTarget, ids)
    this.syncHiddenInputs(this.rejectIdsTarget, ids)
  }

  syncHiddenInputs(container, ids) {
    container.innerHTML = ""
    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "concept_ids[]"
      input.value = id
      container.appendChild(input)
    })
  }

  bulkReject(event) {
    const count = this.itemTargets.filter(cb => cb.checked).length
    if (!confirm(`Reject ${count} suggestion(s)? This cannot be undone.`)) {
      event.preventDefault()
    }
  }
}
